<template>
	<!-- Schedule Details -->
	<v-dialog v-if="localShowDialog && selectedEventData !== null" v-model="localShowDialog" width="fit-content">
		<v-card style="height: 100%" class="mx-auto" :style="{ width: $vuetify.breakpoint.mdAndUp ? '60vw' : '90vw' }">
			<v-card-title class="text-h6 font-semibold card-header fixed-card-title2">
				<div class="truncate-text" style="max-width: calc(100% - 24px)">
					{{ $t('task-list') }} {{ $t('details') }} - {{ selectedEventData.name }}
					<span class="text-subtitle-2">
						({{ formatTimestamp(selectedEventData.start, 'datetime_med') }} -
						{{ formatTimestamp(selectedEventData.end, 'datetime_med') }})
					</span>
				</div>
				<v-spacer />
				<v-icon @click="closeDialog" class="white-icon">mdi-close</v-icon>
			</v-card-title>
			<v-card-text class="overflow-y-auto pt-6">
				<v-row dense>
					<v-col cols="12">
						<v-card>
							<!-- <v-card-title>
								{{ $t('schedule-details') }}
							</v-card-title> -->
							<v-card-text>
								<v-row dense>
									<v-col cols="12" class="text-left">
										<!-- Description -->
										<div class="text-subtitle-1 font-weight-bold">{{ $t('description') }}:</div>
										<!-- prettier-ignore -->
										<div class="text-body-1" style="white-space: pre-wrap">{{ selectedEventData.description || '-' }}</div>
									</v-col>
									<!-- <v-col cols="12" class="text-left">
										<div class="text-subtitle-1 font-weight-bold">{{ $t('locations') }}:</div>
										<v-chip
											v-for="(location, index) in locationListToShow"
											:key="`location-${index}`"
											class="ma-1"
											small
											outlined>
											<v-icon color="primary">mdi-map-marker</v-icon>
											{{ location }}
										</v-chip>
										<v-chip
											small
											color="primary"
											v-if="locationListFull.length > 10"
											@click="showAllLocations = !showAllLocations">
											<span v-if="!showAllLocations"> +{{ locationListFull.length - 10 }} {{ $t('more') }} </span>
											<span v-else>{{ $t('view-less') }}</span>
										</v-chip>
									</v-col> -->
									<v-col cols="12" class="text-left">
										<div class="text-subtitle-1 font-weight-bold">{{ $t('Staff') }}:</div>
										<v-chip
											v-for="(executor, index) in executorListToShow"
											:key="`executor-${index}`"
											class="ma-1"
											small
											outlined>
											{{ executor }}
										</v-chip>
										<v-chip
											small
											color="primary"
											v-if="executorListFull.length > 10"
											@click="showAllExecutors = !showAllExecutors">
											<span v-if="!showAllExecutors"> +{{ executorListFull.length - 10 }} {{ $t('more') }}</span>
											<span v-else>{{ $t('view-less') }}</span>
										</v-chip>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12">
						<v-card>
							<v-card-title>
								<v-row>
									<v-col class="text-left">{{ $t('tasks') }}</v-col>
									<v-col class="text-right" v-if="!addNewTask">
										<v-icon
											color="primary"
											@click="
												addNewTask = true;
												expanded = localTasks.length;
											">
											mdi-plus
										</v-icon>
									</v-col>
								</v-row>
							</v-card-title>
							<v-card-text>
								<div v-if="(localTasks || []).length === 0 && !addNewTask">
									{{ $t('no-tasks-added') }}
								</div>
								<v-expansion-panels v-model="expanded">
									<v-expansion-panel
										v-for="(task, taskIndex) in localTasks"
										:key="task.id"
										:id="`task_${taskIndex}`"
										@click="scrollTo(`task_${taskIndex}`)">
										<v-expansion-panel-header>
											<div class="truncate-text" style="width: calc(100% - 48px)">
												{{ $t('task') }} {{ taskIndex + 1 }}
												<span :style="{ color: getStatusColor(task.status) }">
													({{ statusOptions.find((s) => s.value === task.status)?.label }})
												</span>
												- {{ task.taskDetailDescription }}
											</div>
											<template #actions>
												<v-icon
													color="primary"
													@click.stop="deleteTask(task)"
													v-if="canTaskDetailBeDeleted(task)"
													style="transform: none !important">
													mdi-delete
												</v-icon>
												<v-icon>mdi-chevron-down</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-row dense>
												<v-col cols="12">
													<v-select
														v-model.number="task.taskDetailExecutorBy"
														:label="$t('Staff')"
														item-value="taskExecutorUserId"
														item-text="taskExecutorUserName"
														outlined
														dense
														:items="selectedEventData.schedule.scheduleExecutors"
														hide-details="auto"
														disabled />
												</v-col>
												<!-- Status -->
												<!-- <v-col cols="12">
													<v-select
														v-model="task.status"
														:items="statusOptions"
														:label="$t('status')"
														item-text="label"
														item-value="value"
														outlined
														dense
														hide-details="auto"
														:menu-props="{ offsetY: true }" />
												</v-col> -->
												<!-- taskDetailDescription -->
												<v-col cols="12">
													<v-textarea
														v-model="task.taskDetailDescription"
														rows="3"
														outlined
														hide-details="auto"
														dense
														:label="$t('description')"
														validate-on-blur
														:rules="[(v) => !!v || $t('required-field')]" />
												</v-col>
												<v-col cols="12">
													<v-btn
														block
														color="primary"
														@click="updateTask(task)"
														:disabled="task.taskDetailDescription.trim() === ''">
														{{ $t('update-task') }}
													</v-btn>
												</v-col>
											</v-row>
										</v-expansion-panel-content>
									</v-expansion-panel>
									<v-expansion-panel v-if="addNewTask">
										<v-expansion-panel-header>
											<span>
												{{ $t('new-task') }} {{ $t('for') }} <b>{{ hospitalAssignedData.hospitalName }}</b>
											</span>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-row dense>
												<v-col cols="12">
													<v-select
														v-model.number="taskNew.taskDetailExecutorBy"
														:label="$t('Staff')"
														item-value="taskExecutorUserId"
														item-text="taskExecutorUserName"
														outlined
														dense
														hide-details="auto"
														:menu-props="{ offsetY: true }"
														:items="scheduleExecutors"
														:rules="[(v) => !!v || $t('required-field')]" />
												</v-col>
												<!-- taskDetailDescription -->
												<v-col cols="12">
													<v-textarea
														v-model="taskNew.taskDetailDescription"
														rows="3"
														outlined
														hide-details="auto"
														dense
														:label="$t('description')"
														:rules="[(v) => !!v || $t('required-field')]" />
												</v-col>
												<v-col cols="12">
													<v-btn block color="primary" @click="saveTask" :disabled="!isFormValid">
														{{ $t('save-new-task') }}
													</v-btn>
												</v-col>
											</v-row>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { formatTimestamp, showSuccessAlert } from '../../utils/utilities';

export default {
	props: {
		showDialog: {
			type: Boolean,
			default: false,
		},
		selectedEventData: {
			type: Object,
			default: null,
		},
	},
	data () {
		return {
			localShowDialog: false,
			localTasks: [],
			taskNew: {
				plannedDuration: 0,
				scheduleId: -1,
				organizationId: -1,
				locationId: -1,
				taskTimezoneId: '',
				taskDetailExecutorBy: -1,
				taskActualStartAt: null,
				status: 3, // Default: InProgress
				priority: 3, // Default: Low
				taskDetailDescription: '',
			},
			// filteredTasks is now a computed property (derived from selectedEventData)
			addNewTask: false,
			showAllExecutors: false,
			expanded: null,
		};
	},
	computed: {
		...mapState({
			organizationId: (state) => state.authentication.organizationId,
			authentication: (state) => state.authentication,
			hospitalAssignedData: (state) => state.authentication.userData.hospitalAssignedData,
		}),

		// Cached timezone for performance
		browserTimeZone () {
			return Intl.DateTimeFormat().resolvedOptions().timeZone;
		},

		executorList () {
			return this.selectedEventData?.executors?.split(', ') || [];
		},

		executorListFull () {
			return this.executorList;
		},

		executorListToShow () {
			return this.showAllExecutors ? this.executorListFull : this.executorListFull.slice(0, 10);
		},

		scheduleExecutors () {
			return this.selectedEventData?.schedule?.scheduleExecutors || [];
		},

		// Form validation computed properties
		isExecutorValid () {
			return this.taskNew.taskDetailExecutorBy >= 1;
		},

		isDescriptionValid () {
			return this.taskNew.taskDetailDescription.trim().length > 0;
		},

		isFormValid () {
			return this.isExecutorValid && this.isDescriptionValid;
		},

		// Static options - these don't need to be reactive
		statusOptions () {
			return [
				{ label: this.$t('planned'), value: 0 },
				{ label: this.$t('assigned'), value: 1 },
				{ label: this.$t('in-progress'), value: 2 },
				{ label: this.$t('done'), value: 3 },
				{ label: this.$t('skipped'), value: 4 },
				{ label: this.$t('cancelled'), value: 5 },
				{ label: this.$t('failed'), value: 6 },
			];
		},

		priorityOptions () {
			return [
				{ label: this.$t('high'), value: 1 },
				{ label: this.$t('medium'), value: 2 },
				{ label: this.$t('low'), value: 3 },
			];
		},
	},
	methods: {
		formatTimestamp,
		...mapActions({
			createScheduleTaskDetail: 'schedules/createScheduleTaskDetail',
			editScheduleTaskDetail: 'schedules/editScheduleTaskDetail',
			getSchedulesByLocationId: 'schedules/getSchedulesByLocationId',
		}),
		// Create empty task object
		createEmptyTask () {
			return {
				plannedDuration: 0,
				scheduleId: -1,
				organizationId: -1,
				locationId: -1,
				taskTimezoneId: '',
				taskDetailExecutorBy: -1,
				taskActualStartAt: null,
				status: 3, // Default: InProgress
				priority: 3, // Default: Low
				taskDetailDescription: '',
			};
		},

		// Reset task form
		resetTaskForm () {
			this.taskNew = this.createEmptyTask();
			this.expanded = null;
			if (this.selectedEventData?.occurrence?.occurrenceDuration) {
				this.taskNew.plannedDuration = this.selectedEventData.occurrence.occurrenceDuration;
			}
		},

		async saveTask () {
			const taskPayload = {
				...this.taskNew,
				plannedStartAt: this.selectedEventData.start,
				plannedDuration: this.selectedEventData?.occurrence.occurrenceDuration || 0,
				scheduleId: this.selectedEventData.scheduleId,
				organizationId: this.organizationId,
				locationId: this.hospitalAssignedData.id,
				occurrenceId: this.selectedEventData.occurrence.id,
				taskTimezoneId: this.browserTimeZone,
				taskActualStartAt: new Date().toISOString(),
			};

			try {
				const response = await this.createScheduleTaskDetail(taskPayload);
				if (response.data.resFlag) {
					const selectedHospitalAssignedId = JSON.parse(localStorage.getItem('selectedHospitalAssignedId'));
					await this.getSchedulesByLocationId(selectedHospitalAssignedId);
					this.resetTaskForm();
					showSuccessAlert(this.$t('success'));
				}
			} catch (error) {
				// console.error('Error saving task:', error);
			}
			this.addNewTask = false;
		},

		normalizeOffset (offset) {
			// Ensure +02:00 or -09:30 format
			const match = offset.match(/^([+-]?)(\d{1,2})(?::?(\d{2}))?$/);
			if (!match) return offset;

			const sign = match[1] || '+';
			const hours = match[2].padStart(2, '0');
			const minutes = match[3] || '00';
			return `${sign}${hours}:${minutes}`;
		},

		getStatusColor (status) {
			switch (status) {
				case 0:
					return '#9C27B0'; // Purple for Planned
				case 1:
					return '#2196F3'; // Blue for Assigned
				case 2:
					return '#81C784'; // Light green for In-Progress
				case 3:
					return '#2E7D32'; // Dark green for Done
				case 4:
					return '#FF9800'; // Orange for Skipped
				case 5:
				case 6:
					return '#F44336'; // Red for Cancelled or Failed
				default:
					return 'inherit'; // Default color
			}
		},

		addTimezoneOffset (dateString, timeZone) {
			if (!dateString) return null;

			const date = new Date(dateString);
			if (isNaN(date)) return dateString;

			const formatter = new Intl.DateTimeFormat('en-US', {
				timeZone,
				timeZoneName: 'shortOffset',
			});

			const parts = formatter.formatToParts(date);
			const offsetPart = parts.find((p) => p.type === 'timeZoneName');
			const offset = offsetPart?.value.replace('GMT', '') || '+00:00';

			const normalized = this.normalizeOffset(offset);

			return dateString.replace(/([+-]\d{2}:\d{2}|Z)$/, normalized);
		},
		getMinutesDifferenceFromNow (dateString) {
			const givenDate = new Date(dateString);
			const now = new Date();

			// Validate
			if (isNaN(givenDate)) throw new Error('Invalid date');

			// Difference in milliseconds
			const diffMs = now - givenDate;

			// Convert to minutes
			return diffMs / (1000 * 60);
		},

		closeDialog () {
			this.localShowDialog = false;
		},
		async updateTask (taskToEdit) {
			try {
				var updatePayload;
				if (taskToEdit.status === 3 || taskToEdit.status === 6) {
					const taskStartTime = this.addTimezoneOffset(taskToEdit.taskActualStartAt, taskToEdit.taskTimezoneId);
					const actualTaskDurationInMinutes = Math.round(this.getMinutesDifferenceFromNow(taskStartTime));
					updatePayload = {
						id: taskToEdit.id,
						taskDetailDescription: 'done', // taskToEdit.taskDetailDescription.trim(),
						status: 3, // taskToEdit.status,
						taskActualEndAt: new Date(),
						taskActualDuration: actualTaskDurationInMinutes,
					};
				} else {
					updatePayload = {
						id: taskToEdit.id,
						taskDetailDescription: 'done', // taskToEdit.taskDetailDescription.trim(),
						status: 3, // taskToEdit.status,
					};
				}

				const response = await this.editScheduleTaskDetail(updatePayload);
				if (response.data.resFlag) {
					showSuccessAlert(this.$t('success'));
					const selectedHospitalAssignedId = JSON.parse(localStorage.getItem('selectedHospitalAssignedId'));
					this.$store.dispatch('schedules/getSchedulesByLocationId', selectedHospitalAssignedId);
				}
			} catch (error) {
				// console.error('Error updating task:', error);
			}
		},
		convertBetweenTimeZones (dateTimeString, fromTimeZone, toTimeZone) {
			// Step 1: Parse the input date as if it were in the source time zone
			const dateInSource = new Date(dateTimeString);
			const sourceOptions = { timeZone: fromTimeZone };
			const sourceDate = new Date(dateInSource.toLocaleString('en-US', sourceOptions));

			// Step 2: Calculate UTC equivalent
			const diffMs = dateInSource.getTime() - sourceDate.getTime();
			const utcDate = new Date(dateInSource.getTime() + diffMs);

			// Step 3: Format UTC date in the target time zone
			const targetOptions = {
				timeZone: toTimeZone,
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hour12: false,
			};

			const formatter = new Intl.DateTimeFormat('en-US', targetOptions);
			const parts = formatter.formatToParts(utcDate);

			const get = (type) => parts.find((p) => p.type === type)?.value;

			// Step 4: Build ISO-like string (no 'Z')
			return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`;
		},
		async deleteTask (task) {
			const responseDelete = await this.$store.dispatch('schedules/deleteScheduleTaskDetail', task.id);
			if (responseDelete.data.resFlag) {
				showSuccessAlert(this.$t('success'));
				const selectedHospitalAssignedId = JSON.parse(localStorage.getItem('selectedHospitalAssignedId'));
				this.$store.dispatch('schedules/getSchedulesByLocationId', selectedHospitalAssignedId);
			}
		},
		canTaskDetailBeDeleted (task) {
			return this.authentication.userData.id === task.taskDetailExecutorBy;
		},
		scrollTo (id) {
			const el = document.getElementById(id);
			if (el) {
				setTimeout(() => {
					el.scrollIntoView({ behavior: 'smooth' });
				}, 200);
			}
		},
	},
	watch: {
		showDialog: {
			immediate: true,
			handler (value) {
				this.localShowDialog = value;
				if (value) {
					this.addNewTask = false;
					this.resetTaskForm();
					this.localTasks = JSON.parse(JSON.stringify(this.selectedEventData?.hasTasks || []));
				}
			},
		},
		localShowDialog (value) {
			if (!value) {
				this.$emit('update:showDialog', false);
			}
		},
		selectedEventData (newVal) {
			if (this.localShowDialog) {
				this.localTasks = JSON.parse(JSON.stringify(newVal?.hasTasks || []));
			}
		},
	},
};
</script>
